import { usePunditUserContext } from "@/react/contexts";

export const useIsCustomFontsEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.cms_builder_ui_custom_fonts_enabled);
};
